// extracted by mini-css-extract-plugin
module.exports = {"screen":"screen__3Ljxfx3kAzLXb","block":"block__+PBN0t2tX5dL4","caption":"caption__q-t7YV0f8BEtB","content":"content__JfsdoArsArAmG"};